import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import IconeHay from "../images/logo-loading.png";
import { Link } from 'react-router-dom';
import utilService from '../service/UtilService';
import { toast } from 'react-toastify';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import ApiService from '../service/ApiService';
import { Card } from 'primereact/card';
import { InputOtp } from 'primereact/inputotp';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { SpinRoulette } from 'react-spin-roulette';
import { withRouter } from '../ganchos/withRouter';
import JSConfetti from 'js-confetti'

class Sorteio extends Component {
    constructor(props) {
        super(props);
        this.state = {
            codigo: '',
            mostrarpremio: false,
            premio: {},
            winningIndex: 0,
            customPrizes: [
                { id: '1', label: '🎁 Mystery Box', value: 100 },
                { id: '2', label: '💎 Diamond', value: 500 },
                { id: '3', label: '🏆 Trophy', value: 1000 },
                { id: '4', label: '🎉 Party', value: 250 },
                { id: '5', label: '⭐ Star', value: 750 },
                { id: '6', label: '🚀 Rocket', value: 2000 },
            ]
        }
    }

    pressionar(numero) {
        if (this.state.codigo?.length < 5) {
            this.setState({ codigo: this.state.codigo + String(numero) });
        }

    }
    apagar() {
        if (this.state.codigo) {
            this.setState({ codigo: this.state.codigo.slice(0, -1) });
        }
    }
    
    sortear() {
        // Apenas prêmios disponíveis
        var premiosDisponiveis = this.props.premios.filter(p => p.quantidade > 0);
        if (this.props.eventoParticipante.evento.tieratual){ // se tiver um tier ativado, filtrar apenas premios com tier menor ou igual ao tier atual
            premiosDisponiveis = premiosDisponiveis.filter(p => p.eventocategoriapremio.tier <= this.props.eventoParticipante.evento.tieratual );
        } 
        
        if (!premiosDisponiveis.length){
            return this.setState({ errovisivel: true, erro: "Infelizmente não há mais nenhum prêmio disponivel para o sorteio. Contate o nosso time!", erroHeader: "Nenhum prêmio disponível!"});
        }
        // Soma total dos pesos
        const pesoTotal = premiosDisponiveis.reduce((acc, premio) => {
            return acc + (premio.peso || 0);
        }, 0);

        // Número aleatório entre 0 e pesoTotal
        const random = Math.random() * pesoTotal;

        let acumulado = 0;
        let premioSorteado = null;

        for (const premio of premiosDisponiveis) {
            acumulado += premio.peso || 0;

            if (random <= acumulado) {
                premioSorteado = premio;
                break;
            }
        }

        // Índice original dentro da lista completa
        const winningIndex = this.props.premios.findIndex(
            p => p.id === premioSorteado.id
        );

        this.setState({
            isSpinning: true,
            winningIndex
        });
    }

    async handleCustomComplete() {
        const jsConfetti = new JSConfetti();        
        const premio = this.props.premios[this.state.winningIndex];
        this.setState({ isSpinning: false, premio, mostrarpremio: true });
        await this.animarPremio();
       
    };

    async animarPremio(){
        const premio = this.props.premios[this.state.winningIndex];
        const emoji = premio.nome?.split(' ')[0];
        const jsConfetti = new JSConfetti();
        jsConfetti.addConfetti();
        await jsConfetti.addConfetti({
            emojis: [emoji],
            emojiSize: 50,
            confettiNumber: 30
        });
        jsConfetti.clearCanvas();
    }

    async voltarInicio(sorteio){
        if (sorteio){
            const realizarSorteio = await ApiService.realizarSorteio({
                eventoparticipante: this.props.eventoParticipante.id,
                eventopremio: this.state.premio.id
            });
            switch(realizarSorteio.state){
                case "menu.mensagem.esse.premio.esgotou":
                    alert("Este Premio se esgotou! Contate o nosso setor de suporte.");
                break;
            }
        }        
        this.props.onEventoParticipante({}, []);
        return this.props.navigate("/?idOperacaoTotem=" + this.props.operacaoTotem.id);
    }
    render() {
        const settings = {
            type: 'loop',
            autoplay: true,
            width: '100%'
        };
        return (
            <>

                <ul id="progress-bar" className="entry-bookend-progress-container header fundo-inicial" >

                    <div className="flex flex-column w-full">

                        <Card title={"Código " + this.props.eventoParticipante?.codigo} className="flex-1  lg:m-4 m-2">
                            <p className="">
                                Olá <b>{this.props.eventoParticipante?.nomecompleto}</b>. Esta é sua chance de ganhar prêmios incríveis. Pressione o botão "Sortear" e boa sorte!
                            </p>
                        </Card>
                        <Card title="Boa Sorte!" className="flex-1 lg:m-4 m-2">
                            <SpinRoulette
                                prizes={this.props.premios}
                                winningIndex={this.state.winningIndex}
                                isSpinning={this.state.isSpinning}
                                onComplete={() => this.handleCustomComplete() }
                                className="w-full h-full border-round-xl"
                                prizeClassName="flex items-center justify-center"
                                prizeSize={192}
                                renderPrize={(prize) => (
                                    <div
                                        className="border-round-3xl p-6 h-10rem w-12rem my-2 mx-2 shadow-8 border-2 border-white-alpha-10 flex flex-column align-items-center justify-content-center gap-3 transition-duration-200"
                                        style={{
                                            background: 'linear-gradient(135deg, #39bfef 0%, #6366f1 100%)',
                                            transition: 'transform 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                    >
                                        <div
                                            className="w-4rem h-4rem border-circle flex align-items-center justify-content-center text-4xl shadow-5 flex-shrink-0"
                                            style={{
                                                backgroundColor: 'rgba(255,255,255,0.2)'
                                            }}
                                        >
                                            {prize.nome?.split(' ')[0]}
                                        </div>

                                        <div className="text-center">
                                            <div className="text-sm font-bold text-white">
                                                {prize.nome?.split(' ').slice(1).join(' ')}
                                            </div>

                                            {/*prize.peso !== undefined && (
                                                <div
                                                    className="text-xs font-medium mt-1"
                                                    style={{ color: 'rgba(255,255,255,0.7)' }}
                                                >
                                                    {String(prize.peso)} points
                                                </div>
                                            )*/}
                                        </div>
                                    </div>
                                )}
                                renderIndicator={() => (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            left: '50%',
                                            top: '0',
                                            transform: 'translateX(-50%)',
                                            zIndex: 20,
                                            pointerEvents: 'none',
                                        }}
                                        aria-hidden="true"
                                    >
                                        {/* Arrow pointing down */}
                                        <div
                                            style={{
                                                width: 0,
                                                height: 0,
                                                borderLeft: '24px solid transparent',
                                                borderRight: '24px solid transparent',
                                                borderTop: '36px solid #f97316',
                                                filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.3))',
                                            }}
                                        />
                                    </div>
                                )}
                                duration={4500}
                            />
                            <div className="flex flex-column align-items-center">
                                <Button loading={this.state.isSpinning}
                                    className="flex-shrink-1 mt-5  "
                                    onClick={() => this.sortear()}
                                    icon={<FontAwesomeIcon className={"fa-fw"} icon={"dice"} className="mr-2" />}
                                    disabled={this.state.isSpinning}
                                    label="Realizar Sorteio" />
                                
                            </div>
                        </Card>
                    </div>

                    <Dialog header={this.state.erroHeader} visible={this.state.errovisivel} draggable={false} closable={false} footer={()=> <div><Button label="&nbsp;Ok" icon={<FontAwesomeIcon className={"fa-fw index unselectable"}  icon={"circle-check"} />} onClick={() => this.voltarInicio() } autoFocus /> </div>} onHide={()=> this.setState({ errovisivel: false })}
                        style={{ width: '25vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
                        <p className="m-0">
                            {this.state.erro}
                        </p>
                    </Dialog>

                    <Dialog header="Você ganhou!" visible={this.state.mostrarpremio} draggable={false} closable={false} footer={()=> <div className='flex flex-column align-items-center'><Button label="&nbsp;Receber Prêmio" icon={<FontAwesomeIcon className={"fa-fw index unselectable"}  icon={"circle-check"} />} onClick={() => this.voltarInicio(true) } autoFocus /> </div>} onHide={()=> this.setState({ mostrarpremio: false })}
                        style={{ width: '25vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
                        <p className="m-0 flex flex-column align-items-center">
                            <div onClick={()=> this.animarPremio()}
                                className="border-round-3xl p-6 h-10rem w-12rem my-2 mx-2 shadow-8 border-2 border-white-alpha-10 flex flex-column align-items-center justify-content-center gap-3 transition-duration-200"
                                style={{
                                    background: 'linear-gradient(135deg, #39bfef 0%, #6366f1 100%)',
                                    transition: 'transform 0.2s ease'
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                            >
                                <div
                                    className="w-4rem h-4rem border-circle flex align-items-center justify-content-center text-4xl shadow-5 flex-shrink-0"
                                    style={{
                                        backgroundColor: 'rgba(255,255,255,0.2)'
                                    }}
                                >
                                    {this.state.premio?.nome?.split(' ')[0]}
                                </div>

                                <div className="text-center">
                                    <div className="text-sm font-bold text-white">
                                        {this.state.premio?.nome?.split(' ').slice(1).join(' ')}
                                    </div>

                                    {/*this.state.premio?.peso !== undefined && (
                                        <div
                                            className="text-xs font-medium mt-1"
                                            style={{ color: 'rgba(255,255,255,0.7)' }}
                                        >
                                            {String(this.state.premio?.peso)} points
                                        </div>
                                    )*/}
                                </div>
                            </div>
                        </p>
                        <p className="m-0 flex flex-column align-items-center text-center">
                            <b>{ this.state.premio.descricao}</b>
                        </p>
                    </Dialog>
                </ul>
            </>
        )
    }
}
export default withRouter(Sorteio);
